import { transformPxToRem as t } from "../../../utils/units.es.js";
import { AvatarAnatomy as e } from "./Avatar.anatomy.es.js";
const a = {
  parts: e.keys,
  baseStyle: {
    root: {
      position: "relative",
      width: "fit-content",
      height: "fit-content"
    },
    avatarBox: {
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderColor: "primary.100",
      borderWidth: "1px",
      borderStyle: "solid",
      borderRadius: "full"
    },
    avatarImage: {
      rounded: "full",
      borderRadius: "full",
      objectFit: "cover",
      objectPosition: "top",
      transition: "all 0.25s ease-in-out",
      ":hover": {
        transform: "scale(1.1, 1.1)"
      }
    },
    boxIcon: {
      bg: "primary.700",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 6.5,
      borderRadius: "full",
      position: "absolute",
      bottom: 0,
      right: 0,
      _hover: {
        bg: "primary.400"
      }
    },
    avatarIcon: {
      color: "white"
    },
    button: {
      position: "absolute",
      bottom: 0,
      right: 0,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "full",
      background: "primary.700",
      svg: {
        color: "white"
      },
      _hover: {
        backgroundColor: "primary.500"
      },
      _active: {
        backgroundColor: "primary.700"
      }
    },
    icon: {
      position: "absolute",
      bottom: 0,
      right: 0,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "full",
      backgroundColor: "whiteAlpha.800",
      boxShadow: "50"
    },
    emptyName: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      backgroundColor: "secondary.300",
      fontWeight: 500
    },
    emptyImage: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      backgroundColor: "lightBlue.200"
    }
  },
  sizes: {
    xl: {
      avatarBox: {
        width: 24,
        height: 24,
        fontSize: 32
      },
      boxIcon: {
        width: 6,
        height: 6
      },
      avatarIcon: {
        width: "16px",
        height: "16px"
      },
      button: {
        width: 6,
        height: 6,
        svg: {
          width: 4,
          height: 4
        }
      },
      icon: {
        width: 6,
        height: 6,
        svg: {
          width: 4,
          height: 4
        }
      },
      emptyName: {
        fontSize: t(32)
      },
      emptyImage: {
        svg: {
          width: 10,
          height: 10
        }
      }
    },
    lg: {
      avatarBox: {
        width: 12,
        height: 12,
        fontSize: 16
      },
      boxIcon: {
        width: 5,
        height: 5
      },
      avatarIcon: {
        width: "16px",
        height: "16px"
      },
      button: {
        width: 6,
        height: 6,
        transform: "translate(35%, 25%)",
        svg: {
          width: 4,
          height: 4
        }
      },
      icon: {
        width: 6,
        height: 6,
        transform: "translate(35%, 25%)",
        svg: {
          width: 4,
          height: 4
        }
      },
      emptyName: {
        fontSize: t(16)
      },
      emptyImage: {
        svg: {
          width: 5,
          height: 5
        }
      }
    },
    md: {
      avatarBox: {
        width: 10,
        height: 10,
        fontSize: 14
      },
      boxIcon: {
        width: 4,
        height: 4
      },
      avatarIcon: {
        width: "14px",
        height: "14px"
      },
      button: {
        width: 4.5,
        height: 4.5,
        transform: "translate(35%, 25%)",
        svg: {
          width: 3.5,
          height: 3.5
        }
      },
      icon: {
        width: 4.5,
        height: 4.5,
        transform: "translate(35%, 25%)",
        svg: {
          width: 3.5,
          height: 3.5
        }
      },
      emptyName: {
        fontSize: t(14)
      },
      emptyImage: {
        svg: {
          width: 4,
          height: 4
        }
      }
    },
    sm: {
      avatarBox: {
        width: 8,
        height: 8,
        fontSize: 12
      },
      boxIcon: {
        width: 3,
        height: 3
      },
      avatarIcon: {
        width: "12px",
        height: "12px"
      },
      button: {
        width: 3,
        height: 3,
        transform: "translate(25%, 25%)",
        svg: {
          width: 2,
          height: 2
        }
      },
      icon: {
        width: 3,
        height: 3,
        transform: "translate(25%, 25%)",
        svg: {
          width: 2,
          height: 2
        }
      },
      emptyName: {
        fontSize: t(12)
      },
      emptyImage: {
        svg: {
          width: 3.5,
          height: 3.5
        }
      }
    },
    xs: {
      avatarBox: {
        width: 6,
        height: 6,
        fontSize: 10
      },
      boxIcon: {
        width: 2,
        height: 2
      },
      avatarIcon: {
        width: "10px",
        height: "10px"
      },
      button: {
        width: 3,
        height: 3,
        transform: "translate(35%, 25%)",
        svg: {
          width: 2,
          height: 2
        }
      },
      icon: {
        width: 3,
        height: 3,
        transform: "translate(35%, 25%)",
        svg: {
          width: 2,
          height: 2
        }
      },
      emptyName: {
        fontSize: t(10)
      },
      emptyImage: {
        svg: {
          width: 3,
          height: 3
        }
      }
    }
  },
  variants: {
    round: {},
    square: {
      avatarBox: {
        borderRadius: "radius-50"
      },
      avatarImage: {
        borderRadius: "radius-50"
      }
    }
  },
  defaultProps: {
    size: "md",
    variant: "round"
  }
};
export {
  a as Avatar
};
//# sourceMappingURL=Avatar.es.js.map
